import React from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import Layouts from '../layouts/Layouts';
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material';

const Note = ({ children }) => {
    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Layouts>
            <div>
                <h1>CATATAN DEWAS</h1>
            </div>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/note/form`} className={` sub-menu-item ${split[3] === 'form'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle/>
                                        </div>
                                        <span>Input Catatan Dewas</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/note/data`} className={` sub-menu-item ${split[3] === 'data'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Data Catatan Dewas</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
                
            { children }
        </Layouts>
    )
}

export default Note
